import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const DISMISS_KEY = "pl_install_dismissed";
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  if (!show) return null;
  return (
    <div className="panel mt-6 flex items-start gap-3 border-blue-500/40 p-4" data-testid="install-prompt">
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-blue-500/15 text-blue-400"><Download size={18} /></span>
      <div className="min-w-0 flex-1">
        <p className="font-display text-base font-semibold">Add Quizmoney to your phone</p>
        {deferred ? (
          <>
            <p className="mt-1 text-sm text-slate-400">Open today's puzzles in one tap, every day.</p>
            <button onClick={install} className="btn-primary mt-3 w-full py-2.5 text-sm" data-testid="install-button">Install app</button>
          </>
        ) : (
          <p className="mt-1 text-sm text-slate-400">Tap <Share size={14} className="inline -mt-0.5 text-slate-200" /> Share, then <span className="text-slate-200">Add to Home Screen</span>.</p>
        )}
      </div>
      <button onClick={dismiss} className="rounded-md p-1 text-slate-500 hover:bg-slate-800 hover:text-white" aria-label="Dismiss" data-testid="install-dismiss-button"><X size={16} /></button>
    </div>
  );
}
